module.exports = __webpack_public_path__ + "static/b4-e6edf5e1ea0f2011935d055bc6f47367.jpg";